import React from "react";
import ReactDOM from "react-dom";
import Main from "./js/Main";
import "./css/menu.css";

// import "./css/index.css";
// import "./css/elementsgray.css";
// import "./css/maingray.css";
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from './theme';
 
ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider  theme={theme}>
      {/* <App /> */}
      <React.Fragment>
        <CssBaseline />
        <Main/>
      </React.Fragment>
    </MuiThemeProvider >
  </React.StrictMode>,
  document.getElementById("root")
);
